import { Option, RadioGroupProps } from 'types/button';

import RadioButton from './RadioButton';

const RadioGroup = ({
  options,
  selectedValue,
  handleChange,
  disabled,
  labelStyle = '',
  orientation = 'horizontal',
  className,
  ItemClassName,
  iconStyle = '',
  customTooltipStyle = '',
  optionClassName,
  ...props
}: RadioGroupProps) => {
  const onSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChange(event.target.value);
  };

  return (
    <div
      className={`flex ${
        orientation === 'horizontal' ? 'flex-row' : 'flex-col'
      } ${className || ''}`}
      {...props}
    >
      {options?.map((option: Option) => (
        <div
          key={option.key}
          className={`${
            orientation === 'horizontal' ? 'relative mr-5' : 'mb-3.5'
          } ${optionClassName || ''}`}
        >
          <RadioButton
            className={ItemClassName}
            buttonId={option.id}
            isSelected={selectedValue === option.key}
            onChange={onSelection}
            label={option.value}
            value={option.key}
            key={option.key}
            disabled={disabled || option.disabled}
            labelStyle={labelStyle}
            element={option.element}
            iconStyle={iconStyle}
            tooltipText={option.tooltipText || ''}
            customTooltipStyle={customTooltipStyle}
          />
        </div>
      ))}
    </div>
  );
};

export default RadioGroup;
